import React, { useEffect, useRef } from 'react';
import './App.css';

type OrbSpec = {
  blur: number;
  color: string;
  drift: { x: number; y: number };
  opacity: number;
  size: number;
  start: { x: number; y: number };
};

const BASE_ORBS: OrbSpec[] = [
  {
    size: 220,
    blur: 12,
    opacity: 0.7,
    color: 'rgba(217, 179, 238, 0.78)',
    drift: { x: 0.036, y: 0.026 },
    start: { x: 0.06, y: 0.09 },
  },
  {
    size: 180,
    blur: 11,
    opacity: 0.66,
    color: 'rgba(240, 207, 226, 0.78)',
    drift: { x: -0.031, y: 0.029 },
    start: { x: 0.77, y: 0.68 },
  },
  {
    size: 112,
    blur: 8,
    opacity: 0.62,
    color: 'rgba(201, 167, 236, 0.72)',
    drift: { x: 0.041, y: -0.028 },
    start: { x: 0.28, y: 0.18 },
  },
  {
    size: 96,
    blur: 8,
    opacity: 0.58,
    color: 'rgba(244, 196, 220, 0.72)',
    drift: { x: -0.038, y: -0.026 },
    start: { x: 0.84, y: 0.18 },
  },
  {
    size: 88,
    blur: 7,
    opacity: 0.56,
    color: 'rgba(211, 179, 244, 0.7)',
    drift: { x: 0.03, y: 0.04 },
    start: { x: 0.17, y: 0.72 },
  },
  {
    size: 76,
    blur: 7,
    opacity: 0.58,
    color: 'rgba(233, 196, 232, 0.7)',
    drift: { x: -0.033, y: 0.031 },
    start: { x: 0.59, y: 0.12 },
  },
  {
    size: 70,
    blur: 6,
    opacity: 0.54,
    color: 'rgba(197, 158, 230, 0.66)',
    drift: { x: 0.043, y: 0.024 },
    start: { x: 0.68, y: 0.31 },
  },
  {
    size: 64,
    blur: 6,
    opacity: 0.55,
    color: 'rgba(248, 214, 227, 0.7)',
    drift: { x: -0.028, y: 0.038 },
    start: { x: 0.4, y: 0.79 },
  },
  {
    size: 58,
    blur: 5,
    opacity: 0.52,
    color: 'rgba(206, 180, 237, 0.68)',
    drift: { x: 0.034, y: -0.032 },
    start: { x: 0.08, y: 0.46 },
  },
  {
    size: 54,
    blur: 5,
    opacity: 0.5,
    color: 'rgba(241, 203, 225, 0.68)',
    drift: { x: -0.031, y: -0.03 },
    start: { x: 0.9, y: 0.47 },
  },
  {
    size: 48,
    blur: 4,
    opacity: 0.5,
    color: 'rgba(219, 191, 247, 0.64)',
    drift: { x: 0.039, y: 0.028 },
    start: { x: 0.51, y: 0.61 },
  },
  {
    size: 42,
    blur: 4,
    opacity: 0.48,
    color: 'rgba(246, 214, 232, 0.66)',
    drift: { x: -0.037, y: 0.025 },
    start: { x: 0.34, y: 0.39 },
  },
  {
    size: 38,
    blur: 4,
    opacity: 0.46,
    color: 'rgba(198, 165, 235, 0.62)',
    drift: { x: 0.033, y: -0.035 },
    start: { x: 0.73, y: 0.85 },
  },
  {
    size: 34,
    blur: 3,
    opacity: 0.44,
    color: 'rgba(234, 198, 226, 0.62)',
    drift: { x: -0.029, y: -0.033 },
    start: { x: 0.21, y: 0.89 },
  },
  {
    size: 30,
    blur: 3,
    opacity: 0.42,
    color: 'rgba(210, 183, 244, 0.6)',
    drift: { x: 0.032, y: 0.027 },
    start: { x: 0.12, y: 0.28 },
  },
  {
    size: 28,
    blur: 3,
    opacity: 0.42,
    color: 'rgba(243, 211, 230, 0.62)',
    drift: { x: -0.025, y: 0.03 },
    start: { x: 0.63, y: 0.52 },
  },
  {
    size: 32,
    blur: 3,
    opacity: 0.42,
    color: 'rgba(201, 166, 236, 0.58)',
    drift: { x: 0.027, y: -0.031 },
    start: { x: 0.93, y: 0.24 },
  },
  {
    size: 26,
    blur: 2,
    opacity: 0.4,
    color: 'rgba(246, 218, 233, 0.58)',
    drift: { x: -0.03, y: -0.024 },
    start: { x: 0.3, y: 0.56 },
  },
  {
    size: 24,
    blur: 2,
    opacity: 0.38,
    color: 'rgba(213, 189, 247, 0.56)',
    drift: { x: 0.026, y: 0.022 },
    start: { x: 0.48, y: 0.22 },
  },
  {
    size: 36,
    blur: 3,
    opacity: 0.44,
    color: 'rgba(236, 201, 226, 0.62)',
    drift: { x: -0.034, y: 0.019 },
    start: { x: 0.8, y: 0.56 },
  },
  {
    size: 22,
    blur: 2,
    opacity: 0.38,
    color: 'rgba(198, 168, 234, 0.54)',
    drift: { x: 0.03, y: -0.027 },
    start: { x: 0.55, y: 0.84 },
  },
  {
    size: 27,
    blur: 2,
    opacity: 0.4,
    color: 'rgba(244, 214, 232, 0.58)',
    drift: { x: -0.021, y: -0.031 },
    start: { x: 0.07, y: 0.61 },
  },
  {
    size: 25,
    blur: 2,
    opacity: 0.38,
    color: 'rgba(221, 193, 248, 0.56)',
    drift: { x: 0.029, y: 0.025 },
    start: { x: 0.41, y: 0.08 },
  },
  {
    size: 29,
    blur: 3,
    opacity: 0.42,
    color: 'rgba(240, 206, 227, 0.6)',
    drift: { x: -0.024, y: 0.029 },
    start: { x: 0.88, y: 0.84 },
  },
  {
    size: 21,
    blur: 2,
    opacity: 0.36,
    color: 'rgba(207, 177, 240, 0.54)',
    drift: { x: 0.025, y: -0.022 },
    start: { x: 0.24, y: 0.12 },
  },
  {
    size: 33,
    blur: 3,
    opacity: 0.42,
    color: 'rgba(245, 217, 235, 0.58)',
    drift: { x: -0.028, y: 0.021 },
    start: { x: 0.67, y: 0.92 },
  },
];

const EXTRA_ORBS: OrbSpec[] = Array.from({ length: 24 }, (_, index) => {
  const colors = [
    'rgba(217, 179, 238, 0.54)',
    'rgba(240, 207, 226, 0.56)',
    'rgba(201, 167, 236, 0.5)',
    'rgba(244, 196, 220, 0.5)',
    'rgba(211, 179, 244, 0.48)',
  ];

  return {
    size: 16 + ((index * 7) % 20),
    blur: 2 + (index % 3),
    opacity: 0.28 + (index % 5) * 0.035,
    color: colors[index % colors.length],
    drift: {
      x: (index % 2 === 0 ? 1 : -1) * (0.022 + (index % 4) * 0.004),
      y: (index % 3 === 0 ? -1 : 1) * (0.018 + (index % 5) * 0.003),
    },
    start: {
      x: ((index * 17) % 100) / 100,
      y: ((index * 29 + 11) % 100) / 100,
    },
  };
});

const ORBS: OrbSpec[] = [...BASE_ORBS, ...EXTRA_ORBS];

function App() {
  const orbRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const nodes = orbRefs.current;

    if (!nodes.length) {
      return undefined;
    }

    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    const pointer = {
      active: false,
      x: viewport.width / 2,
      y: viewport.height / 2,
    };

    const orbs = ORBS.map((orb) => ({
      ...orb,
      x: orb.start.x * Math.max(0, viewport.width - orb.size),
      y: orb.start.y * Math.max(0, viewport.height - orb.size),
      baseVx: orb.drift.x,
      baseVy: orb.drift.y,
      vx: orb.drift.x,
      vy: orb.drift.y,
    }));

    const clamp = (value: number, min: number, max: number) => {
      return Math.min(Math.max(value, min), max);
    };

    const applyNodeStyles = () => {
      orbs.forEach((orb, index) => {
        const node = nodes[index];

        if (!node) {
          return;
        }

        node.style.width = `${orb.size}px`;
        node.style.height = `${orb.size}px`;
        node.style.background = orb.color;
        node.style.opacity = `${orb.opacity}`;
        node.style.filter = `blur(${orb.blur}px)`;
        node.style.transform = `translate3d(${orb.x}px, ${orb.y}px, 0)`;
      });
    };

    const keepInside = (orb: (typeof orbs)[number]) => {
      orb.x = clamp(orb.x, 0, Math.max(0, viewport.width - orb.size));
      orb.y = clamp(orb.y, 0, Math.max(0, viewport.height - orb.size));
    };

    applyNodeStyles();

    const handleResize = () => {
      viewport.width = window.innerWidth;
      viewport.height = window.innerHeight;

      orbs.forEach((orb) => {
        keepInside(orb);
      });

      applyNodeStyles();
    };

    const handlePointerMove = (event: PointerEvent) => {
      pointer.active = true;
      pointer.x = event.clientX;
      pointer.y = event.clientY;
    };

    const handlePointerLeave = () => {
      pointer.active = false;
    };

    let animationFrame = 0;
    let lastTime = performance.now();

    const tick = (time: number) => {
      const delta = Math.min(32, time - lastTime);
      lastTime = time;

      orbs.forEach((orb, index) => {
        orb.vx += (orb.baseVx - orb.vx) * 0.015 * delta;
        orb.vy += (orb.baseVy - orb.vy) * 0.015 * delta;

        if (pointer.active) {
          const centerX = orb.x + orb.size / 2;
          const centerY = orb.y + orb.size / 2;
          const dx = centerX - pointer.x;
          const dy = centerY - pointer.y;
          const distance = Math.hypot(dx, dy) || 1;
          const influenceRadius = orb.size * 1.8 + 120;

          if (distance < influenceRadius) {
            const force = ((influenceRadius - distance) / influenceRadius) * 0.009;
            orb.vx += (dx / distance) * force * delta;
            orb.vy += (dy / distance) * force * delta;
          }
        }

        const maxSpeed = orb.size > 160 ? 0.18 : 0.24;
        orb.vx = clamp(orb.vx, -maxSpeed, maxSpeed);
        orb.vy = clamp(orb.vy, -maxSpeed, maxSpeed);

        orb.x += orb.vx * delta;
        orb.y += orb.vy * delta;

        if (orb.x <= 0 || orb.x + orb.size >= viewport.width) {
          orb.baseVx *= -1;
          orb.vx = orb.baseVx;
          orb.vy += orb.baseVy * 0.18;
          orb.x = clamp(orb.x, 0, Math.max(0, viewport.width - orb.size));
        }

        if (orb.y <= 0 || orb.y + orb.size >= viewport.height) {
          orb.baseVy *= -1;
          orb.vy = orb.baseVy;
          orb.vx += orb.baseVx * 0.18;
          orb.y = clamp(orb.y, 0, Math.max(0, viewport.height - orb.size));
        }

        const node = nodes[index];

        if (node) {
          node.style.transform = `translate3d(${orb.x}px, ${orb.y}px, 0)`;
        }
      });

      animationFrame = window.requestAnimationFrame(tick);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerleave', handlePointerLeave);
    animationFrame = window.requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerleave', handlePointerLeave);
      window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <main className="construction-page">
      <div className="construction-grid" aria-hidden="true" />
      {ORBS.map((_, index) => (
        <div
          key={index}
          ref={(node) => {
            orbRefs.current[index] = node;
          }}
          className="construction-orb"
          aria-hidden="true"
        />
      ))}

      <section className="construction-content">
        <p className="construction-kicker">Próximamente</p>
        <img
          className="construction-logo"
          src="/mlanlogo-transparent.png"
          alt="Logo de MLaN Studio"
        />
        <h1 className="construction-title">
          Estamos construyendo el ecosistema más completo para tu marca
        </h1>
      </section>
    </main>
  );
}

export default App;
